module.exports = __webpack_public_path__ + "img/img52.0f583e2d.svg";